/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LessorPurpose,
    LessorPurposeFromJSON,
    LessorPurposeFromJSONTyped,
    LessorPurposeToJSON,
} from './LessorPurpose';
import {
    SocialLoginMessageType,
    SocialLoginMessageTypeFromJSON,
    SocialLoginMessageTypeFromJSONTyped,
    SocialLoginMessageTypeToJSON,
} from './SocialLoginMessageType';
import {
    UserDeviceInformation,
    UserDeviceInformationFromJSON,
    UserDeviceInformationFromJSONTyped,
    UserDeviceInformationToJSON,
} from './UserDeviceInformation';

/**
 * 
 * @export
 * @interface SocialLoginResponseModel
 */
export interface SocialLoginResponseModel {
    /**
     * 
     * @type {number}
     * @memberof SocialLoginResponseModel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    sessionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    role: string;
    /**
     * 
     * @type {boolean}
     * @memberof SocialLoginResponseModel
     */
    canSwitch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    agreementVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    kvkkVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    kvkkInfoVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    ipazVersion?: string | null;
    /**
     * 
     * @type {LessorPurpose}
     * @memberof SocialLoginResponseModel
     */
    lessorPurpose?: LessorPurpose;
    /**
     * 
     * @type {UserDeviceInformation}
     * @memberof SocialLoginResponseModel
     */
    userDeviceInformation?: UserDeviceInformation;
    /**
     * 
     * @type {SocialLoginMessageType}
     * @memberof SocialLoginResponseModel
     */
    type: SocialLoginMessageType;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginResponseModel
     */
    phone?: string | null;
}

export function SocialLoginResponseModelFromJSON(json: any): SocialLoginResponseModel {
    return SocialLoginResponseModelFromJSONTyped(json, false);
}

export function SocialLoginResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialLoginResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'name': json['name'],
        'lastname': json['lastname'],
        'role': json['role'],
        'canSwitch': !exists(json, 'canSwitch') ? undefined : json['canSwitch'],
        'agreementVersion': !exists(json, 'agreementVersion') ? undefined : json['agreementVersion'],
        'kvkkVersion': !exists(json, 'kvkkVersion') ? undefined : json['kvkkVersion'],
        'kvkkInfoVersion': !exists(json, 'kvkkInfoVersion') ? undefined : json['kvkkInfoVersion'],
        'ipazVersion': !exists(json, 'ipazVersion') ? undefined : json['ipazVersion'],
        'lessorPurpose': !exists(json, 'lessorPurpose') ? undefined : LessorPurposeFromJSON(json['lessorPurpose']),
        'userDeviceInformation': !exists(json, 'userDeviceInformation') ? undefined : UserDeviceInformationFromJSON(json['userDeviceInformation']),
        'type': SocialLoginMessageTypeFromJSON(json['type']),
        'message': json['message'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function SocialLoginResponseModelToJSON(value?: SocialLoginResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sessionId': value.sessionId,
        'name': value.name,
        'lastname': value.lastname,
        'role': value.role,
        'canSwitch': value.canSwitch,
        'agreementVersion': value.agreementVersion,
        'kvkkVersion': value.kvkkVersion,
        'kvkkInfoVersion': value.kvkkInfoVersion,
        'ipazVersion': value.ipazVersion,
        'lessorPurpose': LessorPurposeToJSON(value.lessorPurpose),
        'userDeviceInformation': UserDeviceInformationToJSON(value.userDeviceInformation),
        'type': SocialLoginMessageTypeToJSON(value.type),
        'message': value.message,
        'email': value.email,
        'phone': value.phone,
    };
}

